import WILLIAM_HILL from './william-hill';

const COP_THEME = {
  ...WILLIAM_HILL,
  colors: {
    ...WILLIAM_HILL.colors,
    red: '#EA1319',
    grey400: '#E5E7EB',
    supporting: {
      ...WILLIAM_HILL.colors.supporting,
      accent200: '#F4F7FC',
      tertiary: '#0075D4'
    },
    status: {
      ...WILLIAM_HILL.colors.status,
      warning: '#FFF6E3',
      success: '#EAFFF6',
      expired: '#000000',
      unreachable: '#E5E5E5'
    },
    buttons: { ...WILLIAM_HILL.colors.buttons, primary: '#0075D4', primaryContrast: '#ffffff' },
    borderRadius: {
      small: '4px',
      medium: '6px',
      large: '8px',
      xlarge: '10px',
      xxlarge: '20px',
      xxxlarge: '25px'
    }
  }
};

export default COP_THEME;
